<footer class="footer">
    <div class="footer-content">
        <span class="footer-text">&copy; Amadeus Copyright 2017-{{currentYear}}</span>
    </div>
</footer>

